module.exports = __webpack_public_path__ + "img/COM-A-3-I.89da5549.png";